var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_32753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8846 9.375H4.63464V5.3125C4.63588 4.89848 4.8009 4.50177 5.09366 4.20901C5.38641 3.91625 5.78312 3.75124 6.19714 3.75H15.5721C15.9862 3.75124 16.3829 3.91625 16.6756 4.20901C16.9684 4.50177 17.1334 4.89848 17.1346 5.3125V9.375H15.8846Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75964 16.25V11.875C2.7616 11.2126 3.02562 10.5778 3.49404 10.1094C3.96246 9.64098 4.5972 9.37696 5.25964 9.375H16.5096C17.1721 9.37696 17.8068 9.64098 18.2752 10.1094C18.7437 10.5778 19.0077 11.2126 19.0096 11.875V16.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75964 16.25V15.9375C2.76036 15.6891 2.85937 15.451 3.03503 15.2754C3.21069 15.0997 3.44872 15.0007 3.69714 15H18.0721C18.3206 15.0007 18.5586 15.0997 18.7343 15.2754C18.9099 15.451 19.0089 15.6891 19.0096 15.9375V16.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_32753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.884644)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedroom);
export default __webpack_public_path__ + "static/media/bedroom.f3f7cb515d58955783af2fd91f50ed67.svg";
export { ForwardRef as ReactComponent };